const ModalFooter = ({ children }: { children: React.ReactNode }) => {
  return <div className="py-4">{children}</div>;
};

export default ModalFooter;
